import {
  styled,
  ButtonBase,
  Typography,
  ListItem as BaseListItem,
  MenuList as BaseMenuList,
  Paper as BasePaper,
  WithTheme,
} from '@material-ui/core'
import { DropDown, Tick, World } from 'shared/icons'

interface DropDownIconProps extends WithTheme {
  isOpen: boolean
}

interface ListItemProps extends WithTheme {
  isActive: boolean
}

export const POPPER_Z_INDEX = 99

const LIST_ITEM_MIN_WIDTH = 165

export const Icon = styled(World)(({ theme }) => ({
  color: theme.palette.primary.main,
  marginRight: theme.spacing(0.8),
}))

export const Wrapper = styled(ButtonBase)(({ theme }) => ({
  color: theme.palette.primary.main,
  marginRight: theme.spacing(0.8),
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0.8),
  borderRadius: 8,
}))

export const Title = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.black,
  fontWeight: 600,
  fontSize: 14,
  lineHeight: '16px',
}))

export const DropDownIcon = styled(DropDown)(
  ({ theme, isOpen }: DropDownIconProps) => ({
    color: theme.palette.common.black,
    marginLeft: theme.spacing(0.5),
    transform: `rotateZ(${isOpen ? 180 : 0}deg)`,
    transitionProperty: 'transform',
    transitionDuration: '0.3s',
  })
)

export const ListItem = styled(BaseListItem)(
  ({ theme, isActive }: ListItemProps) => ({
    display: 'flex',
    minWidth: LIST_ITEM_MIN_WIDTH,
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(0.8, 2.2),
    ...(isActive
      ? {
          backgroundColor: theme.palette.primary.light,
          fontWeight: 600,
          '&:hover': {
            backgroundColor: theme.palette.primary.light,
          },
        }
      : {}),
  })
)

export const MenuList = styled(BaseMenuList)({
  overflow: 'hidden',
})

export const ActiveItemIcon = styled(Tick)(({ theme }) => ({
  color: theme.palette.common.black,
}))

export const Paper = styled(BasePaper)({
  borderRadius: 8,
})
